import axios from 'axios'
import { useEffect, useState } from 'react'
import Spinner from '../../components/spinner'
import { Search } from '@nine-thirty-five/material-symbols-react/sharp'
import { Button, Card, CardActionArea, CardActions, CardContent, Typography } from '@iziplay/ui-kit'
import { AlbumCover } from '../../components/albumCover'
import { MarqueeText } from '../../components/marqueeText'

function AlbumCard({ release }: { release: any }) {
  const [hovered, setHovered] = useState(false)

  return (
    <Card
      variant="outlined"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <CardActionArea
        to={`/music/${release.artist.id}/${release.id}`}
      >
        <AlbumCover
          src={`${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${release.artist.id}/release/${release.id}/artwork?size=360`}
          animatedSrc={release.hasAnimatedCover ? `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${release.artist.id}/release/${release.id}/artwork/animated` : undefined}
          animate={hovered}
          title={`Cover of ${release.name} by ${release.artist.name}`}
        />
        <CardContent>
          <Typography variant="body1" component="h2">
            <MarqueeText text={release.name} hovered={hovered} />
          </Typography>
          <Typography variant="body2" component="p" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {release.artist.name}
          </Typography>
          {release.year && (
            <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', opacity: 0.55 }}>
              {release.year}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export function Music() {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [releases, setReleases] = useState<any[]>([])

  const fetchReleases = async () => {
    const res = await axios.request({
      method: 'GET',
      url: `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/release/completed`
    })
    setReleases(res.data.releases)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchReleases()
  }, [])

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="scrollable" style={{ paddingBottom: '12px' }}>
      <Card variant="outlined" style={{ marginBottom: '12px' }}>
        <CardContent>
          Cannot find any music you like here? You can try to search it on the engine, maybe we can download it for you!
        </CardContent>
        <CardActions>
          <Button
            to="/music/search"
            variant="text"
            startIcon={<Search size={24} />}
          >
            Search
          </Button>
        </CardActions>
      </Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: '8px', padding: '12px', boxSizing: 'border-box' }}>
        {releases.map(release => (
          <AlbumCard key={release.id} release={release} />
        ))}
      </div>
    </div>
  )
}
